import { useState } from "react";
import { LINE_URL } from "../config/socialLinks";
import s from "./MiyakoWorkDemoPage.module.scss";

const jobs = [
  { name: "Resort Lounge A", area: "平良・西里", pay: "時給 3,500円〜", tags: ["寮あり", "短期OK", "送迎あり"], color: "pink" },
  { name: "Ocean View Club B", area: "平良・下里", pay: "時給 4,000円〜", tags: ["未経験OK", "航空券補助", "日払い可"], color: "blue" },
  { name: "Girls Bar C", area: "平良・西里", pay: "時給 2,500円〜", tags: ["私服OK", "週2日〜", "ノルマなし"], color: "orange" },
];

const MiyakoWorkDemoPage = () => {
  const [period, setPeriod] = useState("1か月");

  return (
    <main className={s.root}>
      <header className={s.header}>
        <a href="#top" className={s.logo}><small>New Club</small> First One <b>RECRUIT</b></a>
        <a href={LINE_URL} target="_blank" rel="noreferrer">LINEで相談</a>
      </header>

      <section className={s.hero} id="top">
        <div className={s.heroImage} />
        <div className={s.heroShade} />
        <div className={s.heroContent}>
          <p className={s.heroScript}>First One Recruit</p>
          <span className={s.heroBadge}>寮付き・短期OKのお仕事</span>
          <h1>昼は海。<br />夜は仕事。</h1>
          <p>宮古島で、ちょっと特別な1か月を。</p>
          <div className={s.heroFacts}>
            <span><b>最短</b>1か月〜</span><span><b>未経験</b>OK</span><span><b>相談</b>無料</span>
          </div>
          <a className={s.mainCta} href={LINE_URL} target="_blank" rel="noreferrer">30秒で希望条件を送る <b>→</b></a>
          <small>まだ応募を決めていなくても相談できます</small>
        </div>
      </section>

      <section className={s.quickSection}>
        <p>あなたの希望は？</p>
        <div className={s.periods}>
          {["2週間", "1か月", "3か月〜"].map((item) => (
            <button type="button" className={period === item ? s.active : ""} onClick={() => setPeriod(item)} key={item}>{item}</button>
          ))}
        </div>
        <strong>{period}から働けるお店を紹介できます</strong>
      </section>

      <section className={s.section}>
        <span className={s.kicker}>LIVE & WORK</span>
        <h2>宮古島で働くって、<br />こんな毎日。</h2>
        <div className={s.dayGrid}>
          <article className={s.dayMain}><span>11:00</span><strong>起きたら、そのまま海へ。</strong><p>仕事は夜から。昼間はビーチやカフェを自由に楽しめます。</p></article>
          <article><span>18:00</span><strong>送迎でお店へ</strong></article>
          <article><span>翌 2:00</span><strong>寮まで送迎</strong></article>
        </div>
      </section>

      <section className={`${s.section} ${s.jobsSection}`}>
        <span className={s.kicker}>JOBS</span>
        <h2>条件を比べて、<br />自分に合うお店を選べます。</h2>
        <div className={s.jobList}>
          {jobs.map((job) => (
            <article className={s.jobCard} key={job.name}>
              <div className={`${s.jobVisual} ${s[job.color]}`}><span>{job.name.slice(-1)}</span><small>店内・寮の写真を掲載</small></div>
              <div className={s.jobBody}>
                <small>{job.area}</small><h3>{job.name}</h3><strong>{job.pay}</strong>
                <div>{job.tags.map((tag) => <span key={tag}>{tag}</span>)}</div>
                <button type="button">詳しい条件を見る <b>→</b></button>
              </div>
            </article>
          ))}
        </div>
        <p className={s.demoNote}>※店舗名・条件はコンセプトデモ用のサンプルです。</p>
      </section>

      <section className={`${s.section} ${s.realitySection}`}>
        <span className={s.kicker}>NO SURPRISES</span>
        <h2>来てから困らないように、<br />知りたいことを全部見せます。</h2>
        <div className={s.checkGrid}>
          {["実際の給与例", "寮の写真・設備", "ノルマ・罰金", "送迎の範囲", "航空券の補助", "生活にかかる費用", "お店の雰囲気", "短期勤務の条件"].map((item) => <div key={item}><span>✓</span>{item}</div>)}
        </div>
      </section>

      <section className={s.storySection}>
        <div className={s.storyImage}><span>▶</span></div>
        <div><span className={s.kicker}>REAL STORY</span><h2>宮古島で働く<br />21歳の1日。</h2><p>寮、休日、仕事、お給料。求人票だけでは分からない生活を、短い動画で正直に紹介します。</p><button type="button">ストーリーを見る</button></div>
      </section>

      <section className={`${s.section} ${s.stepsSection}`}>
        <span className={s.kicker}>HOW TO START</span><h2>応募はLINEで完結。</h2>
        <div className={s.steps}>
          <div><b>01</b><strong>希望条件を送る</strong><small>期間・経験・寮の希望など5項目</small></div>
          <div><b>02</b><strong>合うお店をご紹介</strong><small>条件や雰囲気を比べて選べます</small></div>
          <div><b>03</b><strong>オンライン面談</strong><small>決定後は渡航までサポート</small></div>
        </div>
      </section>

      <section className={s.finalCta}>
        <small>相談だけでもOK</small><h2>宮古島で働くこと、<br />まずLINEで聞いてみる。</h2>
        <a href={LINE_URL} target="_blank" rel="noreferrer">30秒で希望条件を送る <b>→</b></a>
        <p>対象年齢18歳以上（高校生不可）・相談無料</p>
      </section>

      <footer className={s.footer}>CONCEPT DEMO — 実在する求人サービスではありません</footer>
      <a className={s.stickyCta} href={LINE_URL} target="_blank" rel="noreferrer"><span>LINEで</span>30秒応募</a>
    </main>
  );
};

export default MiyakoWorkDemoPage;
